import React from 'react';
import MediaComponent from '../Media/media-component';
import { ButtonSecondary } from '../Buttons/button-component';
import NavLink from '../NavLink/navlink-component';
import { ensureProtocol, isValidUrl } from '../../Services/ApiService';

export const renderParagraphs = (text, textClassName = "") => {
    if (!text) return null;
    const combinedRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|mailto:[^\s@]+@[^\s@]+\.[^\s@]+|tel:\+?[0-9.-]{7,15})/gi;
    return String(text)
        .split('\n\n')
        .map((para, idx) => (
            <p key={idx} className={`mb-6 last:mb-0 leading-relaxed whitespace-pre-line ${textClassName}`}>
                {para.split(combinedRegex).map((part, i) => {
                    const trimmedPart = part.trim();
                    if (isValidUrl(trimmedPart)) {
                        const isExternal = /^https?:\/\/|www\./i.test(trimmedPart);
                        const cleanHref = ensureProtocol(trimmedPart);
                        const displayText = trimmedPart.replace(/^(mailto:|tel:)/i, '');
                        return (
                            <NavLink key={i} href={cleanHref} target={isExternal ? "_blank" : undefined}
                                className="underline font-black text-primary-600 decoration-primary-500/30 underline-offset-4 hover:text-secondary-600 transition-colors">
                                {displayText}
                            </NavLink>
                        );
                    }
                    return <span key={i}>{part}</span>;
                })}
            </p>
        ));
};

const ContentSection = ({
    label,
    title,
    subtitle,
    backgroundImage,
    buttonText,
    onButtonClick,
    buttonHref,
    className = '',
}) => {
    if (!title && !subtitle) return null;

    return (
        <section className={`relative w-full overflow-hidden bg-primary-950 min-h-[280px] flex items-center ${className}`}>

            {/* Background image — full section */}
            {backgroundImage && (
                <div className="absolute inset-0 pointer-events-none">
                    <MediaComponent
                        src={backgroundImage}
                        alt=""
                        className="w-full h-full object-cover opacity-60"
                        wrapperClassName="w-full h-full"
                        useSekeleton={false}
                    />
                    {/* Left fade so text stays readable */}
                    <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/80 to-transparent" />
                </div>
            )}

            {/* Content */}
            <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 lg:px-10 py-12 lg:py-16">
                <div className="max-w-2xl flex flex-col gap-5 text-left">

                    {label && (
                        <span className="text-secondary-500 text-xs font-black uppercase tracking-widest border-b border-secondary-500 w-fit pb-1">
                            {label}
                        </span>
                    )}

                    {title && (
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight text-balance">
                            {title}
                        </h2>
                    )}

                    {subtitle && (
                        <p className="text-neutral-300 text-base md:text-lg font-medium text-pretty leading-relaxed">
                            {subtitle}
                        </p>
                    )}

                    {buttonText && (
                        <div className="mt-2">
                            <ButtonSecondary
                                size="lg"
                                onClick={onButtonClick}
                                href={buttonHref}
                            >
                                {buttonText}
                            </ButtonSecondary>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ContentSection;
